// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Models Overview Page Styles */

.models-overview {
  padding: var(--space-2xl);
  background: transparent;
  min-height: 100vh;
  color: var(--color-text-primary);
}

.models-overview-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: var(--space-2xl);
}

.btn-create-model {
  background: transparent;
  border: 1px solid var(--border-glass);
  color: var(--color-text-primary);
  padding: 0.65rem 1.25rem;
  border-radius: var(--radius-pill);
  font-size: 0.95rem;
  font-weight: 400;
  cursor: pointer;
  transition: var(--transition-normal);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 0.65rem;
}

.btn-create-model:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-2px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
}

.plus-icon {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 30%;
  border: 1.5px solid rgba(255, 255, 255, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-2xl);
  font-weight: 300;
  line-height: 1;
}

/* Section Styles */
.overview-section {
  margin-bottom: 3rem;
}

.section-title {
  font-size: var(--font-size-3xl);
  font-weight: 500;
  color: var(--color-text-primary);
  margin-bottom: var(--space-xl);
}

/* Materials Grid - 3 columns for Recent Views and Your Models */
.materials-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--space-xl);
}

.material-card {
  background: transparent;
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-3xl);
  padding: 1.25rem;
  cursor: pointer;
  transition: var(--transition-normal);
  overflow: hidden;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 240px;
}

.material-card:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-4px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
}

/* Header - Top Right aligned */
.material-header {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: 0.75rem;
}

.material-price {
  font-size: 1.15rem;
  font-weight: 600;
  color: var(--color-text-primary);
  line-height: 1.2;
}

.material-date {
  font-size: var(--font-size-md);
  color: var(--color-text-dim);
  line-height: 1.2;
  margin-top: 0.15rem;
}

/* Chart - Center, Full Width */
.material-chart-wrapper {
  flex: 1 1;
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0.5rem 0;
  min-height: 120px;
}

.material-chart {
  width: 100%;
  display: block;
}

/* Footer - Bottom Left aligned */
.material-footer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 0.75rem;
}

.material-name {
  font-size: var(--font-size-xl);
  font-weight: 600;
  color: var(--color-text-primary);
  line-height: 1.3;
  margin-bottom: 0.15rem;
}

.material-subtitle {
  font-size: var(--font-size-md);
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.2;
}

/* Sectors Grid - 4 columns for Related Fields and All Sectors */
.sectors-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--space-xl);
}

.sector-card {
  background: transparent;
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-3xl);
  overflow: hidden;
  cursor: pointer;
  transition: var(--transition-normal);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
}

.sector-card:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-4px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
}

.sector-image {
  width: 100%;
  height: 160px;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(59, 130, 246, 0.3) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.sector-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.sector-placeholder {
  font-size: 3rem;
  font-weight: 700;
  color: var(--color-text-secondary);
  text-transform: uppercase;
}

.sector-name-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 25%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-3xl);
  font-weight: 700;
  color: var(--color-text-primary);
  text-align: center;
  background: rgba(51, 51, 51, 0.1);
  backdrop-filter: blur(3.75px);
  -webkit-backdrop-filter: blur(3.75px);
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.15), 2px 0 2px rgba(255, 255, 255, 0.15);
  border-left: 1px solid var(--border-faint);
  border-right: 1px solid var(--border-faint);
  border-top: 1px solid var(--border-faint);
  border-bottom: none;
}

.sector-name {
  padding: var(--space-lg);
  font-size: 1.05rem;
  font-weight: 500;
  color: var(--color-text-primary);
  text-align: center;
  background: rgba(20, 20, 35, 0.5);
}

/* Loading and Error States */
.loading-state,
.error-state {
  padding: var(--space-2xl);
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: var(--font-size-xl);
}

.error-state {
  color: rgba(239, 68, 68, 0.8);
}

/* Responsive Design */

/* When sidebar is unpinned (minimized) - more space available */
.content_unpinned .materials-grid {
  grid-template-columns: repeat(4, 1fr);
}

.content_unpinned .sectors-grid {
  grid-template-columns: repeat(4, 1fr);
}

/* When sidebar is pinned (expanded) - standard layout */
.content_pinned .materials-grid {
  grid-template-columns: repeat(3, 1fr);
}

.content_pinned .sectors-grid {
  grid-template-columns: repeat(4, 1fr);
}

/* Tablet view */
@media (max-width: 1200px) {
  .materials-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .sectors-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* Mobile view */
@media (max-width: 768px) {
  .models-overview {
    padding: 1rem;
  }

  .models-overview-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .materials-grid,
  .sectors-grid {
    grid-template-columns: 1fr;
  }

  .btn-create-model {
    width: 100%;
  }
}

/* Sector Models Page - Card Grid Layout */
.models-cards-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--space-xl);
  padding: 0;
}

/* When sidebar is unpinned */
.content_unpinned .models-cards-grid {
  grid-template-columns: repeat(4, 1fr);
}

/* When sidebar is pinned */
.content_pinned .models-cards-grid {
  grid-template-columns: repeat(3, 1fr);
}

/* Tablet view */
@media (max-width: 1200px) {
  .models-cards-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Mobile view */
@media (max-width: 768px) {
  .models-cards-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/models-overview.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC;EACE,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,gCAAgC;EAChC,wBAAwB;EACxB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,gBAAgB;EAChB,2BAA2B;EAC3B,mCAAmC;EACnC,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6FAA6F;EAC7F,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,iCAAiC;EACjC,6BAA6B;EAC7B,qCAAqC;EACrC,qFAAqF;EACrF,0CAA0C;EAC1C,2CAA2C;EAC3C,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA,6BAA6B;AAC7B;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,sBAAsB;;AAEtB,gEAAgE;AAChE;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,wDAAwD;AACxD;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,gBAAgB;AAChB;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA,gBAAgB;AAChB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,qCAAqC;EACrC,oBAAoB;EACpB,UAAU;AACZ;;AAEA,6BAA6B;AAC7B;EACE,qCAAqC;AACvC;;AAEA,2BAA2B;AAC3B;EACE,qCAAqC;AACvC;;AAEA,gBAAgB;AAChB;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,gBAAgB;AAChB;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Models Overview Page Styles */\n\n.models-overview {\n  padding: var(--space-2xl);\n  background: transparent;\n  min-height: 100vh;\n  color: var(--color-text-primary);\n}\n\n.models-overview-header {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-bottom: var(--space-2xl);\n}\n\n.btn-create-model {\n  background: transparent;\n  border: 1px solid var(--border-glass);\n  color: var(--color-text-primary);\n  padding: 0.65rem 1.25rem;\n  border-radius: var(--radius-pill);\n  font-size: 0.95rem;\n  font-weight: 400;\n  cursor: pointer;\n  transition: var(--transition-normal);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n}\n\n.btn-create-model:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.5);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\n}\n\n.plus-icon {\n  width: 1.5rem;\n  height: 1.5rem;\n  border-radius: 30%;\n  border: 1.5px solid rgba(255, 255, 255, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-size-2xl);\n  font-weight: 300;\n  line-height: 1;\n}\n\n/* Section Styles */\n.overview-section {\n  margin-bottom: 3rem;\n}\n\n.section-title {\n  font-size: var(--font-size-3xl);\n  font-weight: 500;\n  color: var(--color-text-primary);\n  margin-bottom: var(--space-xl);\n}\n\n/* Materials Grid - 3 columns for Recent Views and Your Models */\n.materials-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: var(--space-xl);\n}\n\n.material-card {\n  background: transparent;\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-3xl);\n  padding: 1.25rem;\n  cursor: pointer;\n  transition: var(--transition-normal);\n  overflow: hidden;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 240px;\n}\n\n.material-card:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.5);\n  transform: translateY(-4px);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\n}\n\n/* Header - Top Right aligned */\n.material-header {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  margin-bottom: 0.75rem;\n}\n\n.material-price {\n  font-size: 1.15rem;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  line-height: 1.2;\n}\n\n.material-date {\n  font-size: var(--font-size-md);\n  color: var(--color-text-dim);\n  line-height: 1.2;\n  margin-top: 0.15rem;\n}\n\n/* Chart - Center, Full Width */\n.material-chart-wrapper {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin: 0.5rem 0;\n  min-height: 120px;\n}\n\n.material-chart {\n  width: 100%;\n  display: block;\n}\n\n/* Footer - Bottom Left aligned */\n.material-footer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-top: 0.75rem;\n}\n\n.material-name {\n  font-size: var(--font-size-xl);\n  font-weight: 600;\n  color: var(--color-text-primary);\n  line-height: 1.3;\n  margin-bottom: 0.15rem;\n}\n\n.material-subtitle {\n  font-size: var(--font-size-md);\n  color: rgba(255, 255, 255, 0.6);\n  line-height: 1.2;\n}\n\n/* Sectors Grid - 4 columns for Related Fields and All Sectors */\n.sectors-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: var(--space-xl);\n}\n\n.sector-card {\n  background: transparent;\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-3xl);\n  overflow: hidden;\n  cursor: pointer;\n  transition: var(--transition-normal);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n}\n\n.sector-card:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.5);\n  transform: translateY(-4px);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\n}\n\n.sector-image {\n  width: 100%;\n  height: 160px;\n  background: linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(59, 130, 246, 0.3) 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.sector-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.sector-placeholder {\n  font-size: 3rem;\n  font-weight: 700;\n  color: var(--color-text-secondary);\n  text-transform: uppercase;\n}\n\n.sector-name-overlay {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 25%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-size-3xl);\n  font-weight: 700;\n  color: var(--color-text-primary);\n  text-align: center;\n  background: rgba(51, 51, 51, 0.1);\n  backdrop-filter: blur(3.75px);\n  -webkit-backdrop-filter: blur(3.75px);\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.15), 2px 0 2px rgba(255, 255, 255, 0.15);\n  border-left: 1px solid var(--border-faint);\n  border-right: 1px solid var(--border-faint);\n  border-top: 1px solid var(--border-faint);\n  border-bottom: none;\n}\n\n.sector-name {\n  padding: var(--space-lg);\n  font-size: 1.05rem;\n  font-weight: 500;\n  color: var(--color-text-primary);\n  text-align: center;\n  background: rgba(20, 20, 35, 0.5);\n}\n\n/* Loading and Error States */\n.loading-state,\n.error-state {\n  padding: var(--space-2xl);\n  text-align: center;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: var(--font-size-xl);\n}\n\n.error-state {\n  color: rgba(239, 68, 68, 0.8);\n}\n\n/* Responsive Design */\n\n/* When sidebar is unpinned (minimized) - more space available */\n.content_unpinned .materials-grid {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n.content_unpinned .sectors-grid {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n/* When sidebar is pinned (expanded) - standard layout */\n.content_pinned .materials-grid {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.content_pinned .sectors-grid {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n/* Tablet view */\n@media (max-width: 1200px) {\n  .materials-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .sectors-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n/* Mobile view */\n@media (max-width: 768px) {\n  .models-overview {\n    padding: 1rem;\n  }\n\n  .models-overview-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n\n  .materials-grid,\n  .sectors-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .btn-create-model {\n    width: 100%;\n  }\n}\n\n/* Sector Models Page - Card Grid Layout */\n.models-cards-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: var(--space-xl);\n  padding: 0;\n}\n\n/* When sidebar is unpinned */\n.content_unpinned .models-cards-grid {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n/* When sidebar is pinned */\n.content_pinned .models-cards-grid {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n/* Tablet view */\n@media (max-width: 1200px) {\n  .models-cards-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n/* Mobile view */\n@media (max-width: 768px) {\n  .models-cards-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
